import { render, staticRenderFns } from "./Dolading.vue?vue&type=template&id=39be9e54&scoped=true&"
import script from "./Dolading.vue?vue&type=script&lang=js&"
export * from "./Dolading.vue?vue&type=script&lang=js&"
import style0 from "./Dolading.vue?vue&type=style&index=0&id=39be9e54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39be9e54",
  null
  
)

export default component.exports